import React from 'react';
import {Link, useLocation, useNavigate, useSearchParams} from 'react-router-dom';
import styles from './Breadcrumb.module.css';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowLeftLong,
    faBars,
    faChevronLeft,
    faChevronRight,
    faHome, faHomeAlt, faHomeLg, faHomeLgAlt, faHomeUser,
    faSlash
} from "@fortawesome/free-solid-svg-icons";
import {useBreadcrumb} from "../../contexts/BreadcrumbContext";
import Routing from "../../services/routing";
import BackLink from "./Backlink";

const breadcrumbNameMap = {
    [Routing.routes.profil]: 'Profil',
    [Routing.routes.seances]: 'Séances',
    [Routing.routes.seancesAll]: 'Toutes les séances',
    // [Routing.routes.seance]: 'Séance',
    // [Routing.routes.seancesByDate]: 'Séances par date',
    [Routing.routes.seancesDisponibles]: 'Disponibles',
    [Routing.routes.seancesEnregistrees]: 'Enregistrées',
    [Routing.routes.seancesEffectuees]: 'Effectuées',
    [Routing.routes.seancesReferent]: 'Référent',
    [Routing.routes.seancesCoach]: 'Coach',
    [Routing.routes.seancesCoachDisponibles]: 'Disponibles',
    [Routing.routes.seancesCoachEnregistrees]: 'Enregistrées',
    [Routing.routes.seancesCoachEffectuees]: 'Effectuées',
    [Routing.routes.activites]: 'Activités',
    [Routing.routes.planning]: 'Planning',
    // [Routing.routes.myCompany]: 'Ma société',
    [Routing.routes.login]: 'Connexion',
    [Routing.routes.passwordReset]: 'Mot de passe oublié',
    [Routing.routes.passwordNew]: 'Nouveau mot de passe',
    [Routing.routes.profilConfirmation]: 'Confirmation de profil',
    [Routing.routes.profilConfirmationToken]: 'Confirmation de profil',
    [Routing.routes.salaries]: 'Salariés',
    [Routing.routes.salariesImport]: 'Importer un Salarié',
    [Routing.routes.profilEnrolement]: 'Créer un salarié',
    [Routing.routes.salariesCrmHistory]: 'Historique CRM',
    [Routing.routes.mentionsLegales]: 'Mentions légales',
    [Routing.routes.reglementInterieur]: 'Règlement intérieur',
    [Routing.routes.politiqueDeConfidentialite]: 'Politique de confidentialité',
    [Routing.routes.cgu]: 'Conditions générales d\'utilisation',
    [Routing.routes.cgv]: 'Conditions générales de vente',
    [Routing.routes.report]: 'Signaler un problème',
    [Routing.routes.reports]: 'Signalements',
    [Routing.routes.stats]: 'Statistiques',
    [Routing.routes.statsMain]: 'Globales',
    [Routing.routes.statsMois]: 'Du mois',
    [Routing.routes.statsActiviteTypes]: 'Statistiques Activités',
    [Routing.routes.statsUsers]: 'Statistiques utilisateurs',
    [Routing.routes.statsSeances]: 'Statistiques séances',
    [Routing.routes.admin]: 'Administration',
    [Routing.routes.adminEntreprises]: 'Entreprises',
};


const Breadcrumb = () => {
    const { breadcrumb } = useBreadcrumb();
    const { pathname } = useLocation();
    const pathnames = pathname.split('/').filter(x => x);
    let navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'consultation';
    const role = searchParams.get('role') || '';

    const getFriendlyName = (name, routeTo) => {
        const dynamicBreadcrumb = breadcrumb.find(b => b.path === routeTo);
        if (dynamicBreadcrumb) {
            return dynamicBreadcrumb.name;
        }

        if (!isNaN(name)) {
            return 'Détail';
        }
        return breadcrumbNameMap[routeTo];
    };

    return (
        <nav aria-label="breadcrumb" className={styles.breadcrumb}>
            <ol>
                <li>
                    <BackLink className={styles.backLink}>
                        <FontAwesomeIcon icon={faArrowLeftLong} className={styles.chevron}/>
                        Retour
                    </BackLink>
                </li>

                <li>
                    <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                    <Link to={Routing.routes.home}>
                        Accueil
                    </Link>
                </li>

                {pathnames.map((name, index) => {
                    const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
                    const isLast = index === pathnames.length - 1;
                    const friendlyName = getFriendlyName(name, routeTo); // breadcrumbNameMap[routeTo];

                    if (name === 'accueil' || !friendlyName) return null;

                    return (
                        <li key={index}>
                            <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                            <Link to={routeTo}>{friendlyName}</Link>
                        </li>
                    )
                })}
                {mode === 'creation' && (
                    <li>
                        <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                        <span>Création</span>
                    </li>
                )}
                {mode === 'creation_en_masse_csv' && (
                    <li>
                        <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                        <span>Création en masse CSV</span>
                    </li>
                )}
                {role === 'ROLE_COACH' && (
                    <li>
                        <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                        <span>Coachs</span>
                    </li>
                )}
                {role === 'ROLE_REFERENT' && (
                    <li>
                        <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                        <span>Référents</span>
                    </li>
                )}
                {role === 'ROLE_ADMIN' && (
                    <li>
                        <FontAwesomeIcon icon={faChevronRight} className={styles.chevron}/>
                        <span>Administrateurs</span>
                    </li>
                )}
            </ol>
        </nav>
    );
};

export default Breadcrumb;
